var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import SendMessageAsNoteForm from "../../Presentational/Message/SendMessageAsNoteForm";
import SMSForm from "../../Presentational/Message/SMSForm";
import EmailBodyForm from "../../Presentational/Message/EmailBodyForm";
import MessageTemplateService from "../../../Services/MessageTemplate.service";
import useService from "../../Hooks/useService";
import Checkbox from "../../UI/Form/Checkbox";
import useHasPermission from "../../Hooks/useHasPermission";
import MessageThreadService from "../../../Services/MessageThread.service";
import ServiceResult from "../../UI/ServiceResult/ServiceResult";
import AttachmentService from "../../../Services/Attachment.service";
const MessageInlineReplyForm = (_a) => {
    var { personalizationMenus, isEmail, threadId } = _a, formValues = __rest(_a, ["personalizationMenus", "isEmail", "threadId"]);
    const [personalizationMenuState, loadPersonalizationMenus] = useService(MessageTemplateService.getPersonalizationMenus);
    const [canSendAttachmentsInline, loadCanSendAttachmentsInline] = useService(AttachmentService.canSendAttachmentsInline);
    useEffect(() => {
        loadCanSendAttachmentsInline();
    }, [loadCanSendAttachmentsInline]);
    const hasLoggingPermission = useHasPermission("CAN_LOG_MESSAGES");
    const [shouldReplyToThreadDefaultAsLoggedState, loadShouldReplyToThreadDefaultAsLogged,] = useService(MessageThreadService.shouldMessageDefaultAsLogged);
    React.useEffect(() => {
        loadShouldReplyToThreadDefaultAsLogged({ threadId });
    }, [loadShouldReplyToThreadDefaultAsLogged, threadId]);
    const { setValue } = formValues;
    React.useEffect(() => {
        if (hasLoggingPermission &&
            shouldReplyToThreadDefaultAsLoggedState.data &&
            // We don't want to change the value of the checkbox if the user has already interacted with it.
            // Unfortunately checking if the log checkbox has been touched doesn't seem to be working.
            // Checking to see if the user has interacted with any of the fields is the next best thing.
            // If the user has interacted with the form, we don't change the value of the checkbox.
            // The only time this might happen is if the threadId passed into the component changes for some reason.
            Object.keys(formValues.formState.touched).length === 0) {
            setValue("logMessage", true);
        }
    }, [
        formValues.formState.touched,
        hasLoggingPermission,
        setValue,
        shouldReplyToThreadDefaultAsLoggedState.data,
    ]);
    React.useEffect(() => {
        if (personalizationMenus == null) {
            loadPersonalizationMenus();
        }
    }, [loadPersonalizationMenus, personalizationMenus]);
    return (_jsxs(ServiceResult, { state: shouldReplyToThreadDefaultAsLoggedState, children: [isEmail ? (_jsx(EmailBodyForm, Object.assign({}, formValues, { noSubject: true, personalizationMenus: personalizationMenus !== null && personalizationMenus !== void 0 ? personalizationMenus : personalizationMenuState }))) : (_jsx(SMSForm, Object.assign({}, formValues, { personalizationMenus: personalizationMenus !== null && personalizationMenus !== void 0 ? personalizationMenus : personalizationMenuState }))), isEmail && canSendAttachmentsInline && canSendAttachmentsInline.data && (_jsx("div", { className: "form-group", children: _jsx(Checkbox, { label: "Include Attachment Files Directly in the Email", helpText: "Attachments are sent by default as a download link that requires the recipient to log in to SS&E to retrieve the attachment. You may use this option to instead include the attachment directly in the email. This option should only be used in cases where the recipient is likely to not have access to SS&E.", name: "inlineAttachments", ref: formValues.register }) })), hasLoggingPermission && (_jsx("div", { className: "form-group", children: _jsx(Checkbox, { label: "Log Message", name: "logMessage", helpText: "If a student is the recipient of this message, show this message in their Messages and Activity tabs.\n            Logged messages will be stored on the student profile regardless of the delivery status.", ref: formValues.register }) })), _jsx(SendMessageAsNoteForm, Object.assign({}, formValues))] }));
};
export default MessageInlineReplyForm;
